import isEmpty from 'lodash/isEmpty'

export const checkCurrentCategory = ({ categories, currentRouteCategory }) => {
  if (isEmpty(categories)) {
    return {
      isCurrentCategoryCorrect: true,
    }
  }

  const { slug: correctCategory } = categories[categories.length - 1]

  const isCurrentCategoryCorrect =
    currentRouteCategory &&
    correctCategory &&
    currentRouteCategory === correctCategory

  return {
    isCurrentCategoryCorrect,
    correctCategory,
  }
}
